import React from 'react'
import { Grid, Card, CardContent, Typography } from "@deere/fuel-react";
import { getPercentage } from '../../utils/utils';

export default function PercentageCard({ campaign }) {
    const percentage = getPercentage(campaign.noAssignments, campaign.noSubmitted)
    return (
        <>
          <Card>
            <CardContent>
              <Grid container p={3} spacing={6}>
                <Grid item xs={12}>
                  <Typography variant="h2" size="4xl">
                    <Typography variant="span" style={{ color: "#367c2b" }}>{`${percentage}%`}</Typography>
                    {" Responded to-date"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="span" style={{ marginRight: "5px", fontSize: "20px", fontWeight: "bold" }}>
                    {campaign.noSubmitted}
                  </Typography>
                  {"responses out of "}
                  <Typography variant="span" style={{ marginRight: "5px", fontSize: "20px", fontWeight: "bold" }}>
                    {campaign.noAssignments}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>
    );
}